module.exports = __webpack_public_path__ + "static/media/ausvg3.f436cff4.svg";